export default "__VITE_ASSET__Bey35sPF__"